import { cssForBase } from "./sharedImports";

export default (__cssFor) => ({
  ...cssForBase,
  ...__cssFor,
  root: {
    ...cssForBase.root,
    ...__cssFor?.root,
  },
  title: [...cssForBase.title, __cssFor?.title],
  Icon: {
    ...cssForBase.Icon,
    ...__cssFor?.Icon,
    root: [...cssForBase?.Icon?.root, __cssFor?.Icon?.root],
  },
});
